import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

// Registra Service Worker per PWA (solo su desktop)
if ('serviceWorker' in navigator && import.meta.env.DEV && !/Mobi|Android/i.test(navigator.userAgent)) {
  // Registrazione Service Worker manuale per sviluppo (solo desktop)
  navigator.serviceWorker.register('/sw.js').then((registration) => {
    console.log('Service Worker registered:', registration);
    
    // Gestione aggiornamenti
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('New content available, refresh needed');
            if (confirm('Nuova versione disponibile! Vuoi aggiornare?')) {
              window.location.reload();
            }
          }
        });
      }
    });
  }).catch((error) => {
    console.log('Service Worker registration failed:', error);
  });
}

// Gestione installazione PWA
let deferredPrompt: any;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  
  // Mostra pulsante installa se disponibile
  const installButton = document.getElementById('install-button');
  if (installButton) {
    installButton.style.display = 'block';
    installButton.addEventListener('click', () => {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        }
        deferredPrompt = null;
      });
    });
  }
});

// Gestione app installata
window.addEventListener('appinstalled', () => {
  console.log('PWA was installed');
  // Nascondi pulsante installa
  const installButton = document.getElementById('install-button');
  if (installButton) {
    installButton.style.display = 'none';
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
